import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as eventService from "../../services/eventService";
import { handleApiError } from "../storeEffects";
import { EventAction, eventFailure, eventSuccess } from "./storeEvent";

//Effects
export type EventThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, EventAction>

export const getEventPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return eventService.getEventPage()
        .then(
            eventPage => {
                dispatch(eventSuccess(eventPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(eventFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};